import infoCardElement from '../../../components/Utils/Cards/InfoCardMethods';

const generalObject = ({ insurancePolicy, isForm, userModule }) => {
  const {
    accountName,
    accountId,
    accountNationalIdentification,
    beneficiaryPersonName,
    beneficiaryPersonNationalIdentification,
    contractFile,
    contractNumber,
    executiveManagerLabel,
    hiringPersonName,
    hiringPersonNationalIdentification,
    insuranceBrokerName,
    insuranceCategoryName,
    insuranceCompanyName,
    insuredPersonAddress,
    insuredPersonName,
    insuredPersonNationalIdentification,
    paymentPlanName,
    policyNumber,
    policyType,
    subjectMatter,
    subjectMatterAddress,
    translatedCreatedFrom,
    translatedNicoCode,
    translatedPaymentMethod
  } = insurancePolicy;

  const isProposal = policyType === 'proposal';
  const createContractFromProposal = isProposal && contractNumber && contractFile;

  const object = {};

  if (userModule === 'insured')
    object.insuranceBrokerName = infoCardElement({
      string: true,
      key: 'Corredor',
      value: insuranceBrokerName
    });
  object.accountName = infoCardElement({
    link: true,
    key: 'Cuenta',
    value: accountName,
    url: `/admin/accounts/${accountId}`
  });
  if (isForm)
    object.policyNumber = infoCardElement({
      string: true,
      key: isProposal ? 'N° propuesta' : 'N° póliza',
      value: policyNumber
    });
  else
    object.accountNationalIdentification = infoCardElement({
      string: true,
      key: 'RUT Cuenta',
      value: accountNationalIdentification
    });
  if (createContractFromProposal)
    object.contractNumber = infoCardElement({
      string: true,
      key: 'N° póliza',
      value: contractNumber
    });
  object.nicoCode = infoCardElement({
    string: true,
    key: 'Código NICO',
    value: translatedNicoCode
  });
  if (translatedCreatedFrom)
    object.createdFrom = infoCardElement({
      string: true,
      key: 'Tipo de venta',
      value: translatedCreatedFrom
    });
  object.insuranceCompanyName = infoCardElement({
    string: true,
    key: 'Aseguradora',
    value: insuranceCompanyName
  });
  object.insuranceCategoryName = infoCardElement({
    string: true,
    key: 'Ramo',
    value: insuranceCategoryName
  });
  object.subjectMatter = infoCardElement({
    string: true,
    key: 'Materia',
    value: subjectMatter
  });
  object.subjectMatterAddress = infoCardElement({
    string: true,
    key: 'Dirección de riesgo',
    value: subjectMatterAddress || 'No especificada'
  });
  if (insuredPersonName)
    object.insuredPerson = infoCardElement({
      string: true,
      key: 'Asegurado',
      value: `${insuredPersonName} ${insuredPersonNationalIdentification}`
    });
  if (insuredPersonAddress)
    object.insuredPersonAddress = infoCardElement({
      string: true,
      key: 'Dirección comercial asegurado',
      value: insuredPersonAddress
    });
  if (hiringPersonName)
    object.hiringPerson = infoCardElement({
      string: true,
      key: 'Contratante',
      value: `${hiringPersonName} ${hiringPersonNationalIdentification}`
    });
  if (beneficiaryPersonName)
    object.beneficiaryPerson = infoCardElement({
      string: true,
      key: 'Beneficiario',
      value: `${beneficiaryPersonName} ${beneficiaryPersonNationalIdentification}`
    });
  object.paymentPlan = infoCardElement({
    string: true,
    key: 'Plan de pago',
    value: paymentPlanName
  });
  object.paymentMethod = infoCardElement({
    string: true,
    key: 'Forma de pago',
    value: translatedPaymentMethod
  });
  if (executiveManagerLabel)
    object.executiveManager = infoCardElement({
      string: true,
      key: 'Ejecutivo',
      value: executiveManagerLabel
    });

  return object;
};

export default generalObject;
